module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.394a3b33.ttf";